import { StatTile } from "@bruntworkwear-apps/ui";
import { money, quantity, signedMoney } from "@/shared/lib";
import styles from "./RunSummary.module.css";
import type { RunSummaryProps } from "./RunSummary.types";

/**
 * Headline numbers for a run.
 *
 * The adjustable variance is deliberately the emphasised one: the raw variance
 * includes differences below the threshold that nobody is going to post, so it
 * reads worse than the work actually is.
 */
export function RunSummary({ totals, threshold }: RunSummaryProps) {
  const adjustable = totals.adjustable_customs_variance;

  return (
    <div className={styles.grid}>
      <StatTile
        label="Costed lines"
        value={quantity(totals.costed_lines)}
        hint={`of ${quantity(totals.source_rows)} source rows`}
      />
      <StatTile
        label="Purchase orders"
        value={quantity(totals.purchase_orders)}
        hint={`${quantity(totals.flag_count)} flags raised`}
        tone={totals.flag_count > 0 ? "brand" : "neutral"}
      />
      <StatTile
        label="Calculated customs"
        value={money(totals.calculated_customs)}
        hint={`booked ${money(totals.booked_customs)}`}
      />
      <StatTile
        label="Calculated landing"
        value={money(totals.calculated_landing)}
        hint={`booked ${money(totals.booked_landing)}`}
      />
      <StatTile
        label="Adjustable customs variance"
        value={signedMoney(adjustable)}
        hint={`receipts at or over ${money(threshold)}`}
        tone={Math.abs(adjustable) > 0 ? "danger" : "muted"}
      />
      <StatTile
        label="Landing variance"
        value={signedMoney(totals.landing_variance)}
        hint="calculated less booked"
        tone={Math.abs(totals.landing_variance) > 0.01 ? "brand" : "muted"}
      />
    </div>
  );
}
